import ModalPageWrapper from "../../../components/global-layout/modal-page-wrapper";
import OpenExcelModal from "../magics/open-excel-modal-download";

function OpenExcelModalWrapper({
  handleExcelModal,
  magicDataOption,
  setExcelDownloadData,
  handleDownloadReport,
  isExcelLoading,
  excelDownloadData
}: any) {
  return (
    <ModalPageWrapper>
      <div className="w-[33%] h-full bg-io-white dark:bg-io-black-15 ml-auto max-md:w-[85%]">
        <OpenExcelModal
          handleExcelModal={handleExcelModal}
          magicDataOption={magicDataOption}
          setExcelDownloadData={setExcelDownloadData}
          handleDownloadReport={handleDownloadReport}
          isExcelLoading={isExcelLoading}
          excelDownloadData={excelDownloadData}
        />
      </div>
    </ModalPageWrapper>
  );
}
export default OpenExcelModalWrapper;
